import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class DashboardService {
    async getDashboardData(role, isSupplierDashboard) {
        // For "Employee" role, pass an additional param for "Supplier" Dashboard
        let dashboardParams = role === 2 ? `?isSupplier=${isSupplierDashboard}` : "";

        return (await fetchApi.get(`${URL}/dashboard${dashboardParams}`)).data;
    }
}
